var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93799 6C3.85799 6 2.193 7.596 2 9.625C2.506 9.798 9.28198 12.062 9.28198 12.062C10.717 12.541 13.159 12.541 14.594 12.062C14.594 12.062 19.776 10.332 21.907 9.625C21.722 7.588 20.023 6 17.938 6C15.947 6 10.7159 6 5.93799 6Z",
    fill: "#F36D25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.99794C9 4.89394 9.89543 3.99897 11 3.99897H13C14.1046 3.99897 15 4.89394 15 5.99794H17C17 3.78994 15.2091 2 13 2H11C8.79086 2 7 3.78994 7 5.99794H9ZM2 16.0021V11.7233L8.71899 13.9721C10.564 14.5868 13.436 14.5868 15.281 13.9721L22 11.7233V16.0021C22 18.2099 20.209 20 18 20H6C3.791 20 2 18.2099 2 16.0021Z",
    fill: "#F36D25",
    fillOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveReports);
export default __webpack_public_path__ + "static/media/activeReports.7fadac5d519ca76b2de4fb3a532253ab.svg";
export { ForwardRef as ReactComponent };